
<template>
  <div>
    <q-card class="shadow-10-disabled flat bordered card-login">
      <q-card-section class="text-center">
        <a href="https://www.suez.es/es-es">
          <q-img
            style="height: 97px; max-width: 306px"
            :src="require('@/assets/img/logo-dinapsis.svg')"
          />
        </a>
      </q-card-section>
      <q-card-section class="card_titulo">
        <div class="card_titulo_text">Cambiar Contraseña</div>
      </q-card-section>
      <q-card-section class="q-mt-md q-mr-sm">
        <q-input
          minlength="6"
          maxlength="100"
          hint="6 caracteres mínimo. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula"
          v-model="v$.Contraseña.$model"
          outlined
          :error="v$.Contraseña.$error"
          label="Introduce tu nueva contraseña"
          debounce="0"
          bottom-slots
          :type="isPwd ? 'password' : 'text'"
          :rules="[
            (val) =>
              validatePassword(val) ||
              'Contraseña no válida. 6 caracteres mínimo, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
          ]"
        >
          <template
v-slot:error
            >Dato Obligatorio. 6 caracteres mínimo, se requiere al menos 1
            número, 1 letra minúscula y 1 mayúscula.</template
          >
          <template v-slot:append>
            <q-icon
              :name="isPwd ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwd = !isPwd"
            />
          </template>
        </q-input>
      </q-card-section>
      <q-card-section class="q-mt-md q-mr-sm">
        <q-input
          minlength="6"
          maxlength="100"
          required
          hint="6 caracteres mínimo. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula"
          outlined
          debounce="0"
          :error="v$.RepetirContraseña.$error"
          :rules="[
            (val) =>
              val === this.Contraseña || 'Las contraseñas deben coincidir',
            (val) =>
              validatePassword(val) ||
              'Contraseña no válida. 6 caracteres mínimo, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
          ]"
          v-model="v$.RepetirContraseña.$model"
          :type="isPwd2 ? 'password' : 'text'"
          label="Confirmar Contraseña"
          bottom-slots
        >
          <template
v-slot:error
            >Dato Obligatorio. 6 caracteres mínimo, se requiere al menos 1
            número, 1 letra minúscula y 1 mayúscula.</template
          >
          <template v-slot:append>
            <q-icon
              :name="isPwd2 ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwd2 = !isPwd2"
            />
          </template>
        </q-input>
      </q-card-section>
      <q-card-actions class="q-mt-md q-mr-sm" align="right">
        <q-btn
          style="width: 40%; margin-left: 0 !important"
          @click="validar"
          color="primary"
          >Enviar</q-btn
        >
      </q-card-actions>
    </q-card>
  </div>
</template>

<script>
import { required, sameAs } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { QInput, QCardSection, QCardActions, QImg } from 'quasar';
import Validation from '@/components/shared/mixins/Validation.js';
import Message from '@/components/shared/mixins/Message.js';

export default {
  setup: () => ({ v$: useVuelidate() }),
  mixins: [Validation, Message],
  data () {
    return {
      isPwd: true,
      isPwd2: true,
      Contraseña: null,
      RepetirContraseña: null
    };
  },
  validations: {
    Contraseña: { required },
    RepetirContraseña: { required, sameAsPassword: sameAs('Contraseña') }
  },
  methods: {
    validar () {
      this.v$.$touch();

      let email = this.$route.query.email;
      let key = this.$route.query.key;

      if (
        this.v$.$error ||
        !this.comprobarContraseñas(this.Contraseña, this.RepetirContraseña) ||
        this.checkIfEmpty([email, key])
      ) {
        this.showError('Deben introducirse correctamente todos los datos.');
      } else {
        let bodyParams = {
          email: email,
          key: key.replace(/ /g, '+'),
          password: this.Contraseña
        };

        let request = {
          controller: '/User/Password',
          filter: {},
          body: bodyParams
        };

        this.$store
          .dispatch('PF/putSuit', request)
          .then((response) => {
            this.showMessage('Contraseña reseteada correctamente');
            this.$router.push('/login');
          })
          .catch((err) => {
            this.showError(err.message);
            this.$router.push('/login');
          });
      }
    }
  },
  components: {
    QInput,
    QCardSection,
    QCardActions,
    QImg
  }
};
</script>
<style lang="scss" scoped>
.card_titulo_text {
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.64px;
  color: #000000;
}
</style>
